module.exports = __webpack_public_path__ + "static/media/totalPnts_10000_25000.2d66a9a8.png";